export default __webpack_public_path__ + "static/media/asdf.246f4031.png";